import { buildTasks } from '../domains/task-graph/task-builder.js'
import { validateEdge } from '../domains/task-graph/graph-validation.js'

export function createApplication(deps) {
  const listeners = new Set()
  let outputs = deps.outputRepository?.list?.() || []
  let runState = { status: 'idle', completed: 0, total: 0 }
  const notify = () => listeners.forEach((listener) => listener())
  const active = () => deps.workspaceService.active()
  const syncWorkspace = () => deps.workspaceService.replaceCanvas(deps.canvasStore.getState())
  deps.canvasStore.subscribe(() => { syncWorkspace(); notify() })

  async function runGeneration(targetNodeId) {
    const snapshot = deps.canvasStore.getState()
    const plan = buildTasks({ ...snapshot, targetNodeId })
    if (!plan.tasks.length) return { status: 'failed', reason: '没有可运行任务' }
    const jobs = plan.tasks.flatMap((task) => Array.from({ length: Number(task.variants?.[0]?.count || 1) }, (_, index) => ({ ...task, jobId: `${task.id}:${index}` })))
    runState = { status: 'running', completed: 0, total: jobs.length }
    notify()
    const result = await deps.scheduler.run(jobs, {
      execute: async (job) => deps.provider.generate(job),
      onEvent: (entry) => {
        if (entry.type === 'job.succeeded' || entry.type === 'job.failed' || entry.type === 'job.cancelled') runState = { ...runState, completed: runState.completed + 1 }
        if (entry.type === 'run.completed' || entry.type === 'run.failed' || entry.type === 'run.cancelled') runState = { status: entry.type.replace('run.', ''), completed: entry.completed, total: entry.total }
        notify()
      },
    })
    const newOutputs = result.results.filter((item) => item?.status === 'succeeded').flatMap((item) => (item.value.images || []).map((image) => ({ ...image, prompt: item.job.text, taskId: item.job.id, createdAt: Date.now() })))
    outputs = deps.outputRepository?.add?.(newOutputs) || [...newOutputs, ...outputs]
    notify()
    return result
  }

  return {
    getState: () => ({ canvas: deps.canvasStore.getState(), workspace: deps.workspaceService.snapshot(), outputs: [...outputs], run: { ...runState }, config: deps.dataRepository?.config.load?.() || {} }),
    subscribe(listener) { listeners.add(listener); return () => listeners.delete(listener) },
    dispatch: (action) => deps.canvasStore.dispatch(action),
    addEdge(edge) { const result = validateEdge({ ...deps.canvasStore.getState(), edge }); if (result.ok) deps.canvasStore.dispatch({ type: 'canvas.edge.added', edge }); return result },
    undo: () => deps.canvasStore.undo(),
    redo: () => deps.canvasStore.redo(),
    runGeneration,
    createWorkspace: (name) => { deps.workspaceService.replaceCanvas(deps.canvasStore.getState()); const value = deps.workspaceService.create(name); deps.canvasStore.replace(value); notify(); return value },
    activateWorkspace: (id) => {
      deps.workspaceService.replaceCanvas(deps.canvasStore.getState())
      const result = deps.workspaceService.activate(id)
      if (result.ok) deps.canvasStore.replace(result.value)
      notify()
      return result
    },
    saveConfig(config) { deps.dataRepository?.config.save(config); notify() },
    exportBackup: (selection) => deps.backupRepository.export(selection),
    importBackup: (payload) => deps.backupRepository.import(payload),
    activeWorkspace: active,
  }
}
